import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { setSessionStorage } from "utils";

function DropDownComponent({
  items,
  theme,
  extraClassName = "btn-sm",
  centerClass = "",
  menuClass = "border-0 p-0",
  size,
}) {
  const navigate = useNavigate();

  const ThemesJson = {
    theme01: "outline-white",
    theme02: "dark",
    theme03: "white",
    theme04: "white",
  };

  return (
    <Dropdown
      className={`d-flex justify-content-center align-items-center actionDropdown ${centerClass}`}
    >
      <Dropdown.Toggle
        variant={ThemesJson?.[theme]}
        className={`${extraClassName}`}
        size={size}
      >
        {theme !== "theme02" ? (
          <>
            <span className="d-none d-sm-block">Action</span>
            <em className="icon-dots d-block d-sm-none" />
            <em className="icon-arrow-down ms-sm-2 d-none d-sm-block" />
          </>
        ) : (
          <>
            <span>Action</span>
            <em className="icon-arrow-down ms-sm-2 d-none d-sm-block" />
          </>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu size="sm" className={`${menuClass}`}>
        {items?.map((item) => {
          return (
            <Dropdown.Item
              href="#/action-1"
              onClick={(e) => {
                e.preventDefault();
                navigate(item?.path);
                if (item?.theme) setSessionStorage("theme", item?.theme);
                if (item?.onClicks) item?.onClicks();
              }}
              className="d-flex align-items-center"
            >
              <em className={`${item?.icon} me-2`} /> {item?.name}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropDownComponent;
